import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import '@fortawesome/fontawesome-pro/css/fontawesome.css';
import '@fortawesome/fontawesome-pro/css/solid.css';
import '@fortawesome/fontawesome-pro/css/regular.css';
import '@fortawesome/fontawesome-pro/css/light.css';
import '@fortawesome/fontawesome-pro/css/brands.css';

Vue.use(Vuetify);

// Defaults the app uses at first render (kept small + clear)
const FALLBACK_PRIMARY = '#7bc8a3';
const FALLBACK_SECONDARY = '#212121';
const ENV_PRIMARY = process.env.VUE_APP_PRIMARY_COLOR || FALLBACK_PRIMARY;

export const DEFAULT_THEME = {
  primary: ENV_PRIMARY,
  secondary: FALLBACK_SECONDARY,
  accent: '#3497c5',
  error: '#b71c1c',
  info: '#2196F3',
  success: '#4CAF50',
  warning: '#FFC107',
  grey300: '#e0e0e0',
  grey700: '#616161',
  grey50: '#FAFAFA',
  grey800: '#424242',
  calender: '#009E4E',
  material50: '#dff2e8',
  header: '#3497c5',
  partnerHeader: '#f47878',
  directHeader: '#162B44',

  // Your custom “brand” key (kept for compatibility with your code)
  grass: ENV_PRIMARY,
};

const vuetify = new Vuetify({
  icons: { iconfont: 'fa' },
  theme: {
    options: { customProperties: true }, // exposes --v-*-base CSS vars
    dark: false,
    themes: {
      light: { ...DEFAULT_THEME },
      dark: { ...DEFAULT_THEME },
    },
  },
});

export default vuetify;
